// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Drirf","primary":"Button_primary__9JYfe","secondary":"Button_secondary__WS3ms"};